import { render, staticRenderFns } from "./supplierInTransitShow.vue?vue&type=template&id=72456acc&scoped=true"
import script from "./supplierInTransitShow.vue?vue&type=script&lang=js"
export * from "./supplierInTransitShow.vue?vue&type=script&lang=js"
import style0 from "./supplierInTransitShow.vue?vue&type=style&index=0&id=72456acc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72456acc",
  null
  
)

export default component.exports